import Head from "next/head";
import { useRouter } from "next/router";

const SEO = ({
  title = "Petrotec",
  description = "Petrotec presents a range of AdBlue solutions, including storage and supply solutions, at both home-base facilities and points of sale to the public.",
  ogImageWidth = 1200,
  ogImageHeight = 630,
  websiteType,
  ogImage,
  alternates,
}) => {
  const router = useRouter();
  const siteUrl =
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_STRAPI_CLIENT;
  const localePrefix =
    router?.locale &&
    router?.defaultLocale &&
    router.locale !== router.defaultLocale
      ? `/${router.locale}`
      : "";
  const normalizePath = (path) => (path?.startsWith("/") ? path : `/${path}`);
  const rawPath = normalizePath(router?.asPath || "/");
  const pathHasLocale =
    localePrefix &&
    (rawPath === localePrefix || rawPath.startsWith(`${localePrefix}/`));
  const localizedPath =
    localePrefix && !pathHasLocale ? `${localePrefix}${rawPath}` : rawPath;
  const fullTitle = `${title} | ${process.env.NEXT_PUBLIC_SITE_TITLE}`;
  const imageMap = {
    "petrotec-group": "/ogimage-petrotec-group.png",
    petrotec: "/ogimage-petrotec.png",
    petroassist: "/ogimage-petroassist.png",
  };

  const fullImageUrl = siteUrl + (ogImage ? ogImage : imageMap[websiteType]);

  return (
    <Head>
      <title>{fullTitle}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content={description} />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${siteUrl}${localizedPath}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content={ogImageWidth.toString()} />
      <meta property="og:image:height" content={ogImageHeight.toString()} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={`${siteUrl}${localizedPath}`} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      {alternates &&
        alternates.map((alt) => (
          <link
            key={alt.hreflang}
            rel="alternate"
            hreflang={alt.hreflang}
            href={alt.href}
          />
        ))}
    </Head>
  );
};

export default SEO;
